module.exports = __webpack_public_path__ + "static/img/szafa_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_6.jpg
// module id = Kmkb
// module chunks = 0